import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useTranslation } from "react-i18next";
import DatePicker from "@services/ui-components/src/DatePicker/DatePicker";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { OverlayTrigger, Tooltip, Col, Button, Popover, Row, Dropdown } from "react-bootstrap";
import { useParams } from "react-router-dom";
import i18next from "i18next";
import {
    useGetCompanyIdQuery,
    useGetEmployeesPositionsQuery,
} from "@me-team/host/main/employeeList/graphql/employeeList.hooks";
import {
    useGetEmployeeByIdQuery,
    useGetSpecSpecializationQuery,
    useUpdateEmployeeMutation,
} from "@me-team/host/main/addEmployee/graphql/addEmployee.hooks";
import { useResendRegistrationMailMutation } from "@me-team/host/main/updateEmployee/graphql/updateEmployee.hooks";
import {
    AccessDeletionBlockedPopup,
    SpinnerLoader,
    TableHeader,
    TextareaInputWithCounter,
    TooltipCustom,
    WithRoleAccess,
    WithModulesAccess,
} from "@services/ui-components";
import VioletBadge from "@services/ui-components/src/VioletBadge/VioletBadge";
import CustomCreatableReactSelect from "@services/ui-components/src/select/CustomCreatableReactSelect";
import PhonePicker from "@services/ui-components/src/PhonePicker/PhonePicker";
import ImageCrop from "@services/ui-components/src/ImageCrop/ImageCrop";
import DropItem from "@services/ui-components/src/DropItem/DropItem";
import RatingStars from "@services/ui-components/src/RatingStars/RatingStars";
import { addEmployeeFormValidationSchema } from "../AddEmployee/constants/constants";
import Spinner from "@services/ui-components/src/Spinner/Spinner";
import ErrorService from "../../services/ErrorService";
import { ErrorModalComponent } from "@me-pos/error-modal";
import DropPhotosMultiply from "../DropPhotosMultiply/DropPhotosMultiply";
import { processImages } from "../DropPhotosMultiply/drop-photos-utils";
import CustomReactSelect from "@services/ui-components/src/select/CustomReactSelect";
import { ApolloError, useReactiveVar } from "@apollo/client";
import { currentCompanyIdVar } from "@me-team/host/main/globalVar/state";
import AccessSettingsEmployeeTable from "./AccessSettingsEmployeeTable";
import { EmployeeProxy, UserBranchRelationProxy } from "@me-team/host/main/graphql/types";
import { CompanyAccess } from "@me-team/host/main/graphql/types";
import { BranchRoleRelationForEmployee, EmployeeBranchRole } from "./types";
import {
    useCreateUpdateUserBranchRelationMutation,
    useDeleteUserBranchRelationMutation,
} from "@me-team/host/main/setUpAccessRole/graphql/setUpAccessRole.hooks";
import { getArrayForUpdateAccessRights, getBranchIdsForDelete } from "./constants";
import { EmployeeInfo } from "@services/ui-components/src/ModalDelete/AccessDeletionBlockedPopup/AccessDeletionBlockedPopup";
import CreatePositionModal from "../ui-components/CreatePositionModal/CreatePositionModal";
import SalaryModal from "../EmployeesList/modals/SalaryModal/SalaryModal";
import DeleteEmployeeModal from "../EmployeesList/modals/DeleteEmployeeModal/DeleteEmployeeModal";
import BookingSettingsModal from "../EmployeesList/modals/BookingSettingsModal/BookingSettingsModal";
import { useToast } from "../../hooks/useToast";
import { useEmployee } from "@me-team/common/src/hooks/useEmployee";
import ToastComponent from "../ui-components/ToastComponent/ToastComponent";
import { AllModulesTagName } from "../../utils/enums";
import ScrollToErrorHelper from "../../services/ScrollToErrorHelper/ScrollToErrorHelper";
import { useEditingEmployeeAccess } from "./hooks/useEditingEmployeeAccess";

type SetFieldValueType = (field: string, value: string | boolean | string[] | File | (string | File)[]) => void;
type TransformedRole = {
    value: string;
    label: string;
};
const EditingEmployee: React.FC = () => {
    const { id, branchId } = useParams();
    const employeeId = id;
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const basePath = process.env.REACT_APP_POS_URL;
    const currentCompanyId = useReactiveVar(currentCompanyIdVar);
    const [startDate, setStartDate] = useState(null);
    const [showPositionModal, setShowPositionModal] = useState(false);
    const [photosQualification, setPhotosQualification] = useState([]);
    const [isErrorModalOpen, setIsErrorModalOpen] = useState(null);
    const [newPossition, setNewPossition] = useState(null);
    const [key, setKey] = useState(0);
    const [newAccessSettingsState, setNewAccessSettingsState] = useState<BranchRoleRelationForEmployee[]>([]);
    const [showAccessDeletionBlockedPopup, setShowAccessDeletionBlockedPopup] = useState<boolean>(false);
    const [employeeInfo, setEmployeeInfo] = useState<EmployeeInfo>(null);
    const { showToast, setShowToast, toggleShowToast } = useToast();
    const [submitClickedCount, setSubmitClickedCount] = useState(0);
    const [isRegistrationMailSent, setIsRegistrationMailSent] = useState(false);
    const {
        showSalaryModal,
        setShowSalaryModal,
        handleShowSalaryModal,
        selectedEmployee,
        deleteModalShow,
        setDeleteModalShow,
        showBookingSettingsModal,
        handleToggleBookingSettingsModal,
        bookingSettings,
        deleteEmployee,
    } = useEmployee();

    const [showDropdownActions, setShowDropdownActions] = useState<boolean>(false);
    const handleToggleDropdownActions = () => setShowDropdownActions(!showDropdownActions);
    const {
        isEditingOwnProfile,
        employeeActionScope,
        isEmployeePageAccessPending,
        employeePageAccessMode,
        isEmployeePageReadOnly,
        canManageAccessSettings,
        isAccessSettingsReadOnly,
        salaryAccessMode,
        bookingAccessMode,
        canOpenEmployeeServices,
        canOpenSchedule,
        canDismissEmployee,
        hasEmployeePageActions,
    } = useEditingEmployeeAccess({
        employeeId,
    });

    const [resendRegistrationMail, { loading: resendLoading }] = useResendRegistrationMailMutation();

    const handleResendRegistrationMail = async () => {
        const companyId = Number(currentCompanyId);
        const currentBranchId = Number(branchId);
        const employeeId = Number(id);
        if (Number.isNaN(companyId) || Number.isNaN(currentBranchId) || Number.isNaN(employeeId)) return;
        await resendRegistrationMail({
            variables: { companyId, branchId: currentBranchId, employeeId },
            onCompleted: (data) => {
                if (data?.resendRegistrationMail) {
                    setIsRegistrationMailSent(true);
                }
            },
            onError: (error) => setIsErrorModalOpen(ErrorService.errorHandling(error)),
        });
    };

    const {
        data,
        loading,
        refetch: employeesRefetch,
    } = useGetEmployeeByIdQuery({
        variables: {
            employeeId: +id,
            companyId: +currentCompanyId,
        },
        skip: !currentCompanyId || isEmployeePageAccessPending || employeePageAccessMode === "forbidden",
        onCompleted: async (data) => {
            const qualificationConfirmations = data?.user?.company?.employees?.employees[0]?.qualificationConfirmations;
            if (data?.user?.company?.employees?.employees.length === 0) navigate("/*");
            const files = await processImages(qualificationConfirmations, basePath);
            setPhotosQualification(files);
        },
        onError: (error) => {
            setIsErrorModalOpen(ErrorService.errorHandling(error));
        },
        context: {
            errorType: "global",
        },
    });

    const handleChange = (date: string | null | Date, setFieldValue: (field: string, value: string) => void) => {
        if (date) {
            const formattedDate = new Date(date);
            const year = formattedDate.getFullYear();
            const month = String(formattedDate.getMonth() + 1).padStart(2, "0");
            const day = String(formattedDate.getDate()).padStart(2, "0");
            const formattedDateString = `${year}-${month}-${day}`;
            setStartDate(formattedDate);
            setFieldValue("dateOfBirth", formattedDateString);
        } else {
            setStartDate(null);
            setFieldValue("dateOfBirth", null);
        }
    };

    const {
        data: possitions,
        loading: loadingPossitions,
        refetch: refetchPositions,
    } = useGetEmployeesPositionsQuery({
        variables: { companyId: +currentCompanyId },
        skip: !currentCompanyId,
        context: {
            errorType: "local",
        },
        onError: (error) => {
            setIsErrorModalOpen(ErrorService.errorHandling(error));
        },
    });
    const { data: companyId, loading: loadingCompanyId } = useGetCompanyIdQuery({
        variables: { companyId: +currentCompanyId },
        skip: !currentCompanyId,
        onError: (error) => {
            setIsErrorModalOpen(ErrorService.errorHandling(error));
        },
        context: {
            errorType: "global",
        },
    });

    const { data: dataSpecialization, loading: loadingSpecialization } = useGetSpecSpecializationQuery({
        variables: { branchId: Number(branchId) },
        context: {
            errorType: "local",
        },
        onError: (error) => {
            setIsErrorModalOpen(ErrorService.errorHandling(error));
        },
    });
    const specialization = dataSpecialization?.employeeSpecializations;

    const [updateEmployee] = useUpdateEmployeeMutation({
        context: {
            errorType: "local",
        },
        onError: (error) => {
            setIsErrorModalOpen(ErrorService.errorHandling(error));
        },
    });

    const [deleteUserBranchRelation, { loading: deleteUserBranchRelationLoading }] =
        useDeleteUserBranchRelationMutation({
            context: {
                errorType: "local",
            },
            onError: (error) => {
                setIsErrorModalOpen(ErrorService.errorHandling(error));
            },
        });

    const [createUserBranchRelation, { loading: createUserBranchRelationLoading }] =
        useCreateUpdateUserBranchRelationMutation({
            context: {
                errorType: "local",
            },
            onError: (error) => {
                setIsErrorModalOpen(ErrorService.errorHandling(error));
            },
        });

    const handlePositionModal = () => {
        setShowPositionModal((prevState) => !prevState);
        setKey((prevKey) => prevKey + 1);
    };

    const setFieldConfirmation = (setFieldValue: SetFieldValueType) => {
        setFieldValue("isUpdateConfirmations", true);
    };
    const employees: EmployeeProxy = data?.user?.company?.employees?.employees[0];
    const canShowResendRegistrationMail = !isEmployeePageReadOnly && employees?.isActive === false;
    const userBranchRelations: UserBranchRelationProxy[] = employees?.userBranchRelations;
    const formattedArrayBranchAndRoleRelation: BranchRoleRelationForEmployee[] =
        userBranchRelations?.map((relation) => ({
            relation: relation.id,
            branch: { id: relation.branch.id, name: relation.branch.name },
            role: { id: relation.role.id, name: relation.role.name, isOwner: relation.role.isOwner },
        })) || [];
    const employeeRoleForCurrentBranch: number = newAccessSettingsState?.find((item) => item.branch.id === +branchId)
        ?.role.id;
    const isEmployeeFired = employees?.status?.id === 4;
    const isEmployeeTariffBlocked = Boolean(employees?.tariffBlocking);
    const isEmployeeOwner = Boolean(employees?.role?.isOwner);
    const isDismissActionDisabled = isEditingOwnProfile || isEmployeeOwner;

    const handleOpenSalarySettings = () => {
        if (salaryAccessMode === "hidden" || isEmployeeTariffBlocked) return;
        handleShowSalaryModal(employees);
    };

    const handleOpenEmployeeServices = () => {
        if (!canOpenEmployeeServices || isEmployeeTariffBlocked) return;
        navigate(`/employees-list/employee-services/${id}/${branchId}`);
    };

    const handleOpenWorkSchedule = () => {
        if (!canOpenSchedule || isEmployeeFired || isEmployeeTariffBlocked) return;
        navigate(`/work-schedule/${id}/${branchId}`);
    };

    const handleOpenBookingSettings = () => {
        if (bookingAccessMode === "hidden" || isEmployeeFired || isEmployeeTariffBlocked) return;
        bookingSettings(employees);
    };

    const handleOpenDismissEmployee = () => {
        if (!canDismissEmployee || isDismissActionDisabled) return;
        deleteEmployee(employees);
    };

    useEffect(() => {
        setIsRegistrationMailSent(false);
    }, [id]);

    useEffect(() => {
        document.title = ` ${t(isEmployeePageReadOnly ? "View" : "Edit")} ${employees?.name} ${employees?.surname}`;
    }, [employees?.name, employees?.surname, isEmployeePageReadOnly, t]);

    const addContract = (index: number, file: string, setFieldValue: SetFieldValueType): void => {
        setFieldValue("contract", file);
        setFieldValue("isUpdateContract", true);
    };
    const handlePhoto = (setFieldValue: SetFieldValueType) => {
        setFieldValue("isUpdateImage", true);
    };

    const maxDate = new Date();
    maxDate.setFullYear(maxDate.getFullYear() - 14);

    const transform = (original: string): TransformedRole => ({
        value: original,
        label: original,
    });

    const handleCloseAccessDeletionBlockedPopup = () => {
        setShowAccessDeletionBlockedPopup(false);
    };

    if (!currentCompanyId || isEmployeePageAccessPending) {
        return <Spinner />;
    }

    if (
        loadingPossitions ||
        loadingCompanyId ||
        loading ||
        loadingSpecialization ||
        deleteUserBranchRelationLoading ||
        createUserBranchRelationLoading ||
        !employees
    )
        return <Spinner />;

    return (
        <>
            <VioletBadge>
                {t(
                    "Required fields are marked with an asterisk *. The data that customers see in the online record form is marked "
                )}{" "}
                <i className="bi bi-info-circle"></i>
            </VioletBadge>
            <TableHeader
                title={` ${t("Edit")} ${employees?.name} ${employees?.surname}`}
                paths={[
                    { path: location?.pathname, label: "Personnel management" },
                    {
                        path: `/employees-list/${branchId}`,
                        label: "List of employees",
                    },
                    { path: location?.pathname, label: "Edit" },
                ]}
                buttons={
                    hasEmployeePageActions ? (
                        <div className="d-flex justify-content-end mt-4 mt-lg-0">
                            <div className="col-12 col-sm-4 col-xl-4 col-xxl-3">
                                <Dropdown
                                    className="dropdown-action"
                                    show={showDropdownActions}
                                    onToggle={handleToggleDropdownActions}
                                    drop={"down-centered"}
                                >
                                    <Dropdown.Toggle variant="outline-primary" id="actionsDropdown" className="w-100">
                                        <div className="d-flex justify-content-between">
                                            <span className="me-2">{t("Actions")}</span>
                                            <i
                                                className={`bi bi-chevron-down transition-icon ${showDropdownActions ? "rotate-up" : ""}`}
                                            ></i>
                                        </div>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <WithModulesAccess modules={[AllModulesTagName.SALARY]}>
                                            {salaryAccessMode !== "hidden" ? (
                                                <Dropdown.Item
                                                    className="py-2"
                                                    onClick={handleOpenSalarySettings}
                                                    disabled={isEmployeeTariffBlocked}
                                                >
                                                    <i className="bi bi-cash-coin me-2"></i>
                                                    {t("Salary settings")}
                                                </Dropdown.Item>
                                            ) : null}
                                        </WithModulesAccess>
                                        <WithModulesAccess modules={[AllModulesTagName.SERVICES]}>
                                            <WithRoleAccess
                                                permission={CompanyAccess.EmployeeServicesView}
                                                scope={employeeActionScope}
                                            >
                                                <Dropdown.Item
                                                    className="py-2"
                                                    onClick={handleOpenEmployeeServices}
                                                    disabled={isEmployeeTariffBlocked}
                                                >
                                                    <i className="bi bi-bookmark me-2"></i>
                                                    {t("Employee's services")}
                                                </Dropdown.Item>
                                            </WithRoleAccess>
                                        </WithModulesAccess>
                                        <WithModulesAccess modules={[AllModulesTagName.WORK_SCHEDULE]}>
                                            <WithRoleAccess
                                                permission={CompanyAccess.ScheduleCalendarView}
                                                scope={employeeActionScope}
                                            >
                                                <Dropdown.Item
                                                    className="py-2"
                                                    onClick={handleOpenWorkSchedule}
                                                    disabled={isEmployeeFired || isEmployeeTariffBlocked}
                                                >
                                                    <i className="bi bi-calendar4-week me-2"></i>
                                                    {t("Work schedule")}
                                                </Dropdown.Item>
                                            </WithRoleAccess>
                                        </WithModulesAccess>
                                        <WithModulesAccess modules={[AllModulesTagName.BOOKING]}>
                                            {bookingAccessMode !== "hidden" ? (
                                                <Dropdown.Item
                                                    className="py-2"
                                                    onClick={handleOpenBookingSettings}
                                                    disabled={isEmployeeFired || isEmployeeTariffBlocked}
                                                >
                                                    <i className="bi bi-gear me-2"></i>
                                                    {t("Booking Settings")}
                                                </Dropdown.Item>
                                            ) : null}
                                        </WithModulesAccess>
                                        <WithRoleAccess
                                            permission={CompanyAccess.EmployeeDismiss}
                                            scope={employeeActionScope}
                                        >
                                            <Dropdown.Item
                                                className="py-2"
                                                onClick={handleOpenDismissEmployee}
                                                disabled={isDismissActionDisabled}
                                            >
                                                <i className="bi bi-person-dash me-2"></i>
                                                {t("Fire an employee")}
                                            </Dropdown.Item>
                                        </WithRoleAccess>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    ) : null
                }
                colSize={7}
                btnColSize={5}
            />

            <Formik
                initialValues={{
                    company: companyId?.user.company.id,
                    name: employees?.name,
                    surname: employees?.surname,
                    email: employees?.email?.trim() || "",
                    phone: employees?.phone,
                    specialization: employees?.specialization,
                    employeePosition: employees?.position.id,
                    role: employeeRoleForCurrentBranch ? employeeRoleForCurrentBranch : employees?.role.id,
                    tariffBlocking: employees?.tariffBlocking,
                    manualBlocking: employees?.manualBlocking,
                    status: +employees?.status.id,
                    patronymic: employees?.patronymic,
                    dateOfBirth: employees?.dateOfBirth,
                    passportData: employees?.passportData,
                    itn: employees?.itn,
                    aboutMe: employees?.aboutMe,
                    isUpdateConfirmations: false,
                    showSurnameInBooking: employees.recordSetting.isShowSurname,
                }}
                enableReinitialize
                validationSchema={addEmployeeFormValidationSchema(t)}
                onSubmit={async (values, { setSubmitting, setErrors }) => {
                    if (isEmployeePageReadOnly) {
                        setSubmitting(false);
                        return;
                    }
                    if (!currentCompanyId) {
                        setSubmitting(false);
                        return;
                    }
                    try {
                        const cleanedPhotosQualification = photosQualification?.filter((photo) => photo != null);
                        const updatedValues = {
                            ...values,
                            email: values.email?.trim() || "",
                            role: employeeRoleForCurrentBranch ? employeeRoleForCurrentBranch : employees?.role.id,
                            qualificationConfirmations: cleanedPhotosQualification,
                        };
                        const employeeId: number = Number(id);
                        let branchIdsForDelete: number[] = getBranchIdsForDelete(
                            formattedArrayBranchAndRoleRelation,
                            newAccessSettingsState
                        );
                        const arrForUpdateAccessRights: EmployeeBranchRole[] = getArrayForUpdateAccessRights(
                            formattedArrayBranchAndRoleRelation,
                            newAccessSettingsState,
                            employeeId
                        );

                        branchIdsForDelete.length > 0 &&
                            canManageAccessSettings &&
                            (await new Promise((resolve, reject) => {
                                deleteUserBranchRelation({
                                    variables: {
                                        companyId: +currentCompanyId,
                                        ids: branchIdsForDelete,
                                        branchId: +branchId,
                                    },
                                    onCompleted: (data) => {
                                        resolve(data);
                                    },
                                    onError: (error) => {
                                        if (error.graphQLErrors) {
                                            const gqlError = error.graphQLErrors[0];
                                            const category = gqlError.extensions?.category;

                                            if (category === "booking.actual_items") {
                                                const match = gqlError.message.match(
                                                    /Employee \[id: \d+, name: ([^\]]+)] has actual bookings in branch \[id: (\d+), name: ([^\]]+)]/
                                                );
                                                if (match) {
                                                    const employeeName = match[1];
                                                    const branchId = match[2];
                                                    const branchName = match[3];
                                                    setEmployeeInfo({
                                                        name: employeeName,
                                                        surname: "",
                                                        branch: branchName,
                                                        branchId: +branchId,
                                                    });
                                                    setShowAccessDeletionBlockedPopup(true);
                                                }
                                            }
                                            reject(error);
                                        }
                                    },
                                });
                            }));
                        arrForUpdateAccessRights.length > 0 &&
                            canManageAccessSettings &&
                            (await createUserBranchRelation({
                                variables: {
                                    companyId: +currentCompanyId,
                                    input: arrForUpdateAccessRights,
                                    branchId: +branchId,
                                },
                            }));

                        await updateEmployee({
                            variables: {
                                id: employees?.id,
                                input: updatedValues,
                                companyId: +currentCompanyId,
                                branchId: +branchId,
                            },
                            context: {
                                errorType: "local",
                            },
                            onCompleted: () => {
                                setNewAccessSettingsState([]);
                                navigate(`/employees-list/${branchId}`, { state: { text: t("Saved"), toast: true } });
                            },
                            onError: (error: ApolloError) => {
                                setIsErrorModalOpen(ErrorService.errorHandling(error));
                            },
                        });
                    } catch (error) {
                        console.error("Error creating employee:", error);
                        const graphQLError = error.graphQLErrors?.[0];
                        if (
                            graphQLError?.extensions?.validation?.phone?.[0]?.message ===
                            "This value is not a valid phone number."
                        ) {
                            setErrors({ phone: t("Invalid phone number") });
                        } else if (graphQLError?.message === "Employee already exists") {
                            console.error("Error", graphQLError.message);
                            setErrors({ email: `Email  ${values.email} ${t("already exists in system.")}` });
                        }
                    } finally {
                        setSubmitting(false);
                    }
                }}
            >
                {({ errors, touched, setFieldValue, values, handleSubmit, isSubmitting }) => {
                    return (
                        <>
                            <ScrollToErrorHelper errors={errors} submitClickedCount={submitClickedCount} />
                            <CreatePositionModal
                                key={key}
                                show={showPositionModal}
                                handleModal={handlePositionModal}
                                companyId={companyId?.user.company.id}
                                refetch={refetchPositions}
                                setNewPossition={setNewPossition}
                                setFieldValue={setFieldValue}
                            />
                            <Form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="d-flex flex-column flex-lg-row gap-5 gap-lg-0">
                                        <Col xs={12} lg={9} className="me-0 pe-lg-5">
                                            <div className="row ">
                                                <h4 className="fw-normal">{t("Personal data")}</h4>
                                            </div>
                                            <div className="row mt-sm-4">
                                                <div className="col-sm-3 col-md-2 mt-2 pt-1 mb-2 mb-sm-0">
                                                    <span className="text-dark fw-bold">
                                                        <small>
                                                            <label
                                                                htmlFor="editEmployee-name-field"
                                                                className="mb-0 text-dark form-label required-label"
                                                            >
                                                                {t("Name")}
                                                            </label>
                                                        </small>
                                                    </span>
                                                </div>
                                                <div className="col-sm-9 col-md-10">
                                                    <div className="position-relative">
                                                        <Field
                                                            type="text"
                                                            name="name"
                                                            id="editEmployee-name-field"
                                                            className={`fs-7 form-control ${errors.name && touched.name ? "border-danger" : ""}`}
                                                            maxLength="50"
                                                            disabled={isEmployeePageReadOnly}
                                                        />
                                                        <div className="position-absolute top-50 end-0 translate-middle-y ">
                                                            <OverlayTrigger
                                                                overlay={
                                                                    <Tooltip>
                                                                        {t(
                                                                            "This data is displayed in the Online Booking form"
                                                                        )}
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <div className=" position-absolute top-50 translate-middle-y end-0 me-3">
                                                                    <i className="bi bi-info-circle"></i>
                                                                </div>
                                                            </OverlayTrigger>
                                                        </div>
                                                    </div>
                                                    <ErrorMessage name="name">
                                                        {(msg) => <p className="fs-7 p-1 text-danger m-0">{msg}</p>}
                                                    </ErrorMessage>
                                                </div>
                                            </div>

                                            <div className="row mt-sm-4">
                                                <div className="col-sm-3 col-md-2 mt-2 pt-1 mb-2 mb-sm-0">
                                                    <span className="text-dark fw-bold">
                                                        <small>
                                                            <label
                                                                htmlFor="editEmployee-surname-field"
                                                                className="mb-0 text-dark form-label required-label"
                                                            >
                                                                {t("Last name")}{" "}
                                                            </label>
                                                        </small>
                                                    </span>
                                                </div>
                                                <div className="col-sm-9 col-md-10">
                                                    <div className="position-relative">
                                                        <Field
                                                            id="editEmployee-surname-field"
                                                            type="text"
                                                            name="surname"
                                                            placeholder={t("Add Last name")}
                                                            maxLength="50"
                                                            className={`fs-7 form-control ${errors.surname && touched.surname ? "border-danger" : ""}`}
                                                            disabled={isEmployeePageReadOnly}
                                                        />
                                                        <div className="position-absolute top-50 end-0 translate-middle-y ">
                                                            <OverlayTrigger
                                                                overlay={
                                                                    <Tooltip>
                                                                        {t(
                                                                            "This data is displayed in the Online Booking form"
                                                                        )}
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <div className="position-absolute top-50 translate-middle-y end-0 me-3">
                                                                    <i className="bi bi-info-circle"></i>
                                                                </div>
                                                            </OverlayTrigger>
                                                        </div>
                                                    </div>
                                                    <ErrorMessage name="surname">
                                                        {(msg) => <p className="fs-7 m-0 p-1 text-danger">{msg}</p>}
                                                    </ErrorMessage>
                                                </div>
                                            </div>
                                            <div className="row mt-2">
                                                <div className="offset-sm-3 offset-md-2 col-sm-9 col-md-10 pe-lg-5">
                                                    <div className="position-relative d-flex">
                                                        <Field
                                                            type="checkbox"
                                                            name="showSurnameInBooking"
                                                            id="editEmployee-showSurnameInBooking-checkbox"
                                                            className="form-check-input"
                                                            checked={!values.showSurnameInBooking}
                                                            onChange={() => {
                                                                if (isEmployeePageReadOnly) return;
                                                                setFieldValue(
                                                                    "showSurnameInBooking",
                                                                    !values.showSurnameInBooking
                                                                );
                                                            }}
                                                            disabled={isEmployeePageReadOnly}
                                                        />
                                                        <label
                                                            className="form-check-label ms-2 fs-7"
                                                            htmlFor="editEmployee-showSurnameInBooking-checkbox"
                                                        >
                                                            {t("Do not display Surname in Online-booking form")}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mt-sm-4">
                                                <div className="col-sm-3 col-md-2 mt-2 pt-1 mb-2 mb-sm-0">
                                                    <span className="text-dark fw-bold">
                                                        <small>
                                                            <label
                                                                htmlFor="editEmployee-middleName-field"
                                                                className="mb-0 text-dark form-label"
                                                            >
                                                                {t("Middle name")}
                                                            </label>
                                                        </small>
                                                    </span>
                                                </div>
                                                <div className="col-sm-9 col-md-10">
                                                    <div className="position-relative">
                                                        <Field
                                                            id="editEmployee-middleName-field"
                                                            type="text"
                                                            name="patronymic"
                                                            maxLength="50"
                                                            placeholder={t("Add Middle name")}
                                                            className="fs-7 form-control"
                                                            disabled={isEmployeePageReadOnly}
                                                        />
                                                    </div>
                                                    <ErrorMessage name="patronymic">
                                                        {(msg) => <p className="fs-7 m-0 p-1 text-danger">{msg}</p>}
                                                    </ErrorMessage>
                                                </div>
                                            </div>
                                            <WithModulesAccess modules={[AllModulesTagName.REVIEWS]}>
                                                <div className="row mt-sm-4">
                                                    <div className="col-sm-3 col-md-2 mb-2 mb-sm-0">
                                                        <span className="text-dark fw-bold">
                                                            <small>
                                                                <label className="mb-0 text-dark form-label required">
                                                                    {t("rating")}
                                                                </label>
                                                            </small>
                                                        </span>
                                                    </div>
                                                    <div className="col-sm-9 col-md-10 pe-lg-5 d-flex justify-content-start">
                                                        <RatingStars rating={employees?.reviews} />
                                                    </div>
                                                </div>
                                            </WithModulesAccess>
                                            <div className="row mt-sm-4">
                                                <div className="col-sm-3 col-md-2 mt-2 pt-1 mb-2 mb-sm-0">
                                                    <span className="text-dark fw-bold">
                                                        <small>
                                                            <label
                                                                htmlFor="editEmployee-date-field"
                                                                className="mb-0 text-dark form-label required"
                                                            >
                                                                {t("Date of birth")}{" "}
                                                            </label>
                                                        </small>
                                                    </span>
                                                </div>
                                                <div className="col-sm-9 col-md-10">
                                                    <div className="position-relative">
                                                        <DatePicker
                                                            id="editEmployee-date-field"
                                                            className="form-control w-100"
                                                            wrapperClassName="w-100"
                                                            placeholderText={t("dd.mm.yyyy")}
                                                            selected={
                                                                startDate
                                                                    ? startDate
                                                                    : employees?.dateOfBirth &&
                                                                      new Date(employees?.dateOfBirth)
                                                            }
                                                            onChange={(date) => handleChange(date, setFieldValue)}
                                                            dateFormat="dd.MM.yyyy"
                                                            maxDate={maxDate}
                                                            yearDropdownItemNumber={124}
                                                            isClearable
                                                            disabled={isEmployeePageReadOnly}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mt-sm-4">
                                                <div className="col-sm-3 col-md-2 mt-2 pt-1 mb-2 mb-sm-0">
                                                    <span className="text-dark fw-bold">
                                                        <small>
                                                            <label
                                                                htmlFor="editEmployee-E-mail-field"
                                                                className="mb-0 text-dark form-label required-label"
                                                            >
                                                                {t("E-mail")}
                                                            </label>
                                                        </small>
                                                    </span>
                                                </div>
                                                <div className="col-sm-9 col-md-10">
                                                    <div className="position-relative">
                                                        <Field
                                                            id="editEmployee-E-mail-field"
                                                            type="email"
                                                            name="email"
                                                            maxLength="50"
                                                            placeholder={t("Add e-mail")}
                                                            className={`fs-7 form-control ${errors.email && touched.email ? "border-danger" : ""}`}
                                                            style={
                                                                canShowResendRegistrationMail
                                                                    ? { paddingRight: "110px" }
                                                                    : undefined
                                                            }
                                                            readOnly
                                                        />
                                                        {canShowResendRegistrationMail && (
                                                            <div className="position-absolute top-50 end-0 translate-middle-y d-flex align-items-center gap-2 pe-2">
                                                                <Button
                                                                    type="button"
                                                                    variant="link"
                                                                    className={`fs-7 p-0 ${isRegistrationMailSent ? "text-decoration-none" : ""}`}
                                                                    disabled={resendLoading || isRegistrationMailSent}
                                                                    onClick={handleResendRegistrationMail}
                                                                >
                                                                    {isRegistrationMailSent ? (
                                                                        <>
                                                                            {t("Sent")}
                                                                            <i
                                                                                className="bi bi-check-lg ms-1"
                                                                                aria-hidden="true"
                                                                            ></i>
                                                                        </>
                                                                    ) : (
                                                                        t("Resend")
                                                                    )}
                                                                </Button>
                                                                <TooltipCustom
                                                                    placement="top"
                                                                    text={t(
                                                                        "A registration link will be sent to the email"
                                                                    )}
                                                                >
                                                                    <span className="bi bi-info-circle d-inline-flex align-items-center justify-content-center lh-1" />
                                                                </TooltipCustom>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <ErrorMessage name="email">
                                                        {(msg) => <p className="fs-7 m-0 p-1 text-danger">{msg}</p>}
                                                    </ErrorMessage>
                                                </div>
                                            </div>

                                            <div className="row mt-sm-4">
                                                <div className="col-sm-3 col-md-2 mt-2 pt-1 mb-2 mb-sm-0">
                                                    <span className="text-dark fw-bold">
                                                        <small>
                                                            <label
                                                                htmlFor="editEmployee-phone-field"
                                                                className="mb-0 text-dark form-label required-label"
                                                            >
                                                                {t("Phone")}{" "}
                                                            </label>
                                                        </small>
                                                    </span>
                                                </div>
                                                <div className="col-sm-9 col-md-10">
                                                    <PhonePicker
                                                        name="phone"
                                                        value={employees?.phone}
                                                        id="editEmployee-phone-field"
                                                        disabled={isEmployeePageReadOnly}
                                                    />
                                                    <ErrorMessage name="phone">
                                                        {(msg) => <p className="fs-7 m-0 p-1 text-danger">{msg}</p>}
                                                    </ErrorMessage>
                                                </div>
                                            </div>

                                            <div className="row mt-sm-4">
                                                <div className="col-sm-3 col-md-2 mt-2 pt-1 mb-2 mb-sm-0">
                                                    <span className="text-dark fw-bold">
                                                        <small>
                                                            <label
                                                                htmlFor="editEmployee-passportData-field"
                                                                className="mb-0 text-dark form-label required"
                                                            >
                                                                {t("Passport Data")}
                                                            </label>
                                                        </small>
                                                    </span>
                                                </div>
                                                <div className="col-sm-9 col-md-10">
                                                    <div className="position-relative">
                                                        <Field
                                                            id="editEmployee-passportData-field"
                                                            maxLength="10"
                                                            type="text"
                                                            name="passportData"
                                                            placeholder={t("Enter Passport Data")}
                                                            className="fs-7 form-control"
                                                            disabled={isEmployeePageReadOnly}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-sm-9 col-md-10 ms-auto">
                                                    <ErrorMessage name="passportData">
                                                        {(msg) => <p className="fs-7 m-0 p-1 text-danger">{msg}</p>}
                                                    </ErrorMessage>
                                                    <span className="text-grey fs-7">
                                                        {" "}
                                                        {values?.passportData?.length || 0}/10
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="row mt-sm-4">
                                                <div className="col-sm-3 col-md-2 mt-2 pt-1 mb-2 mb-sm-0">
                                                    <span className="text-dark fw-bold">
                                                        <small>
                                                            <label
                                                                htmlFor="editEmployee-SSN-field"
                                                                className="mb-0 text-dark form-label required"
                                                            >
                                                                {t("SSN (Social Security Number)")}{" "}
                                                            </label>
                                                        </small>
                                                    </span>
                                                </div>
                                                <div className="col-sm-9 col-md-10">
                                                    <div className="position-relative">
                                                        <Field
                                                            id="editEmployee-SSN-field"
                                                            maxLength="20"
                                                            type="text"
                                                            name="itn"
                                                            placeholder={t("Enter SSN")}
                                                            className="fs-7 form-control"
                                                            disabled={isEmployeePageReadOnly}
                                                        />
                                                    </div>
                                                    <ErrorMessage name="itn">
                                                        {(msg) => <p className="fs-7 m-0 p-1 text-danger">{msg}</p>}
                                                    </ErrorMessage>
                                                </div>
                                            </div>

                                            <div className="row mt-sm-4">
                                                <div className="col-sm-3 col-md-2 mt-2 pt-1 mb-2 mb-sm-0">
                                                    <span className="text-dark fw-bold">
                                                        <small>
                                                            <label
                                                                htmlFor="editEmployee-About-field"
                                                                className="mb-0 text-dark form-label required"
                                                            >
                                                                {t("About")}{" "}
                                                            </label>
                                                        </small>
                                                    </span>
                                                </div>
                                                <div className="col-sm-9 col-md-10">
                                                    <TextareaInputWithCounter
                                                        id="addEmployee-About-field"
                                                        name="aboutMe"
                                                        maxLength={400}
                                                        inputCol={12}
                                                        placeholder={t(
                                                            "Enter a short description for the master presentation"
                                                        )}
                                                        disabledLabel
                                                        infoText="This data is displayed in the Online Booking form"
                                                        disabled={isEmployeePageReadOnly}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row mt-5">
                                                <h4 className="text-dark fw-normal">{t("Professional Information")}</h4>
                                            </div>
                                            <div className="row mt-sm-4">
                                                <div className="col-sm-3 col-md-2 mt-2 pt-1 mb-2 mb-sm-0">
                                                    <span className="text-dark fw-bold">
                                                        <small>
                                                            <label
                                                                htmlFor="position-field"
                                                                className="mb-0 text-dark form-label required-label"
                                                            >
                                                                {t("Position")}
                                                            </label>
                                                        </small>
                                                    </span>
                                                </div>
                                                <div className="col-sm-9 col-md-10">
                                                    <div className="position-relative">
                                                        <div className="d-flex align-items-center w-100">
                                                            <div className="w-100">
                                                                <div className="position-relative w-100">
                                                                    <CustomReactSelect
                                                                        key={key}
                                                                        optionsArray={
                                                                            possitions?.user.company.employeePositions
                                                                                .employeePositions
                                                                        }
                                                                        placeholder={
                                                                            employees?.position?.name ||
                                                                            t("Select Position")
                                                                        }
                                                                        setField={setFieldValue}
                                                                        fieldName="employeePosition"
                                                                        value="id"
                                                                        isTooltip={true}
                                                                        initialValue={
                                                                            newPossition ||
                                                                            transform(employees?.position?.name)
                                                                        }
                                                                        name={"position-field"}
                                                                        id={"editEmployee-Position-field"}
                                                                        disabled={isEmployeePageReadOnly}
                                                                    />

                                                                    <div
                                                                        className="position-absolute top-50 end-0 translate-middle-y "
                                                                        style={{ height: "16px", paddingRight: "12px" }}
                                                                    >
                                                                        <OverlayTrigger
                                                                            overlay={
                                                                                <Popover>
                                                                                    <Popover.Body>
                                                                                        <Row>
                                                                                            <p className="m-0 mb-1">
                                                                                                {t(
                                                                                                    "The position is displayed inside the system, and the specialization is in the form of an online record."
                                                                                                )}{" "}
                                                                                            </p>
                                                                                        </Row>
                                                                                    </Popover.Body>
                                                                                </Popover>
                                                                            }
                                                                        >
                                                                            <div className=" position-absolute top-50 translate-middle-y end-0 me-3">
                                                                                <i className="bi bi-info-circle"></i>
                                                                            </div>
                                                                        </OverlayTrigger>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <Button
                                                                    type="button"
                                                                    onClick={handlePositionModal}
                                                                    variant="outline-gray"
                                                                    className=" text-dark ms-2  px-3 border square-btn"
                                                                    style={{ minWidth: "50px", height: "50px" }}
                                                                    disabled={isEmployeePageReadOnly}
                                                                >
                                                                    <i className="bi bi-plus-lg"></i>
                                                                </Button>
                                                            </div>
                                                        </div>
                                                        <ErrorMessage name="employeePosition">
                                                            {(msg) => <p className="fs-7 m-0 p-1 text-danger">{msg}</p>}
                                                        </ErrorMessage>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mt-sm-4">
                                                <div className="col-sm-3 col-md-2 mt-2 pt-1 mb-2 mb-sm-0">
                                                    <span className="text-dark fw-bold">
                                                        <small>
                                                            <label
                                                                htmlFor="specialization-field"
                                                                className="mb-0 text-dark form-label required-label"
                                                            >
                                                                {t("Specialization")}
                                                            </label>
                                                        </small>
                                                    </span>
                                                </div>
                                                <div className="col-sm-9 col-md-10">
                                                    <div className="position-relative">
                                                        <CustomCreatableReactSelect
                                                            optionsArray={specialization}
                                                            placeholder={t("Enter specialization")}
                                                            setField={setFieldValue}
                                                            fieldName="specialization"
                                                            value="name"
                                                            isTooltip={true}
                                                            initialValue={transform(employees?.specialization || "")}
                                                            name={"specialization-field"}
                                                            id={"editEmployee-specialization-field"}
                                                            maxLength={50}
                                                            createOptionLabel={t("Create a specialization")}
                                                            noOptionsText={t("Start typing the specialization name")}
                                                            createOnBlur={true}
                                                            disabled={isEmployeePageReadOnly}
                                                        />
                                                        <div
                                                            className="position-absolute top-50 end-0 translate-middle-y "
                                                            style={{ height: "16px", paddingRight: "12px" }}
                                                        >
                                                            <OverlayTrigger
                                                                overlay={
                                                                    <Tooltip>
                                                                        {t(
                                                                            "This data is displayed in the Online Booking form"
                                                                        )}
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <div className=" position-absolute top-50 translate-middle-y end-0 me-3">
                                                                    <i className="bi bi-info-circle"></i>
                                                                </div>
                                                            </OverlayTrigger>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-9 col-md-10 ms-auto">
                                                    <span className="text-grey fs-7">
                                                        {values?.specialization?.length || 0}/50
                                                    </span>
                                                    <ErrorMessage name="specialization">
                                                        {(msg) => <p className="fs-7 m-0 p-1 text-danger">{msg}</p>}
                                                    </ErrorMessage>
                                                </div>
                                            </div>

                                            <div className="row mt-sm-4">
                                                <div className="col-sm-3 col-md-2 mt-2 pt-1 mb-2 mb-sm-0">
                                                    <span className="text-dark fw-bold">
                                                        <small>
                                                            <label className="mb-0 text-dark form-label required">
                                                                {t("Qualification Confirmation")}
                                                            </label>
                                                        </small>
                                                    </span>
                                                </div>

                                                <div className="col-sm-9 col-md-10">
                                                    <div className="mb-2 ps-sm-1 text-dark">
                                                        <span>
                                                            {t(
                                                                "Add PNG, JPG, JPEG, WEBP images of diplomas, certificates"
                                                            )}{" "}
                                                        </span>
                                                        <OverlayTrigger
                                                            overlay={
                                                                <Tooltip>
                                                                    {t(
                                                                        "This data is displayed in the Online Booking form"
                                                                    )}
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <i className="bi bi-info-circle pe-6"></i>
                                                        </OverlayTrigger>
                                                    </div>
                                                    <div className="col-12 col-lg-10 ">
                                                        <div className="row m-0">
                                                            <DropPhotosMultiply
                                                                photosArray={photosQualification}
                                                                setPhotos={setPhotosQualification}
                                                                disabled={isEmployeePageReadOnly}
                                                                setConfiramitoinField={() =>
                                                                    setFieldConfirmation(setFieldValue)
                                                                }
                                                            />
                                                        </div>
                                                        <span className="text-grey fs-7">
                                                            {" "}
                                                            {t("Maximum size: 3 MB")}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mt-sm-4">
                                                <div className="col-sm-3 col-md-2 mt-2 pt-1 mb-2 mb-sm-0">
                                                    <span className="text-dark fw-bold">
                                                        <small>
                                                            <label className="mb-0 text-dark form-label required">
                                                                {" "}
                                                                {t("Contract")}
                                                            </label>
                                                        </small>
                                                    </span>
                                                </div>

                                                <div className="col-sm-9 col-md-10">
                                                    <DropItem
                                                        index={0}
                                                        handleFile={setFieldValue}
                                                        fieldName={"contract"}
                                                        file={true}
                                                        previewFile={employees?.contract}
                                                        setFieldValue={setFieldValue}
                                                        handleFileCallback={addContract}
                                                        dismissFile={() => setFieldValue("isUpdateContract", true)}
                                                        disabled={isEmployeePageReadOnly}
                                                    />
                                                </div>
                                                <div className="col-sm-9 col-md-10 ms-auto mt-2">
                                                    <span className="text-grey fs-7">
                                                        {t("Document formats: PDF, DOC, DOCX")}
                                                    </span>
                                                </div>
                                            </div>
                                            <WithRoleAccess permission={CompanyAccess.AccessSettingsView}>
                                                <AccessSettingsEmployeeTable
                                                    userBranchRelations={formattedArrayBranchAndRoleRelation}
                                                    setNewAccessSettingsState={setNewAccessSettingsState}
                                                    isReadOnly={isAccessSettingsReadOnly}
                                                />
                                            </WithRoleAccess>
                                        </Col>
                                        <Col xs={12} lg={3} className="ps-lg-3 ps-0 mt-4 mt-lg-0">
                                            <h4 className="text-dark pb-3 mt-1">{t("Employee's photo")}</h4>
                                            <ImageCrop
                                                previewPhoto={employees?.image}
                                                setFieldValue={setFieldValue}
                                                fieldSetter={() => handlePhoto(setFieldValue)}
                                                fieldName="image"
                                                dismissImage={() => setFieldValue("isUpdateImage", true)}
                                                modalTitle={t("Employee's photo")}
                                                notBGinfo
                                                disabled={isEmployeePageReadOnly}
                                            />
                                        </Col>
                                    </div>
                                    <div className="d-sm-flex mb-5 mt-3">
                                        <Link
                                            to={`/employees-list/${branchId}`}
                                            className=" btn btn-outline-primary fw-normal mb-3 mb-sm-0 me-3 custom-btn rounded-1"
                                            onClick={() => navigate(`/employees-list/${branchId}`)}
                                        >
                                            {t("Cancel")}
                                        </Link>
                                        <Button
                                            type="button"
                                            onMouseDown={() => {
                                                if (isEmployeePageReadOnly) return;
                                                setSubmitClickedCount((prev) => prev + 1);
                                            }}
                                            onClick={() => {
                                                if (isEmployeePageReadOnly) return;
                                                handleSubmit();
                                            }}
                                            variant="primary"
                                            className="fw-bold custom-btn rounded-1"
                                            disabled={isSubmitting || isEmployeePageReadOnly}
                                        >
                                            {isSubmitting ? (
                                                <SpinnerLoader variant="light" loadingText={t("Saving...")} />
                                            ) : (
                                                t("save")
                                            )}
                                        </Button>
                                    </div>
                                </div>
                            </Form>
                        </>
                    );
                }}
            </Formik>
            <AccessDeletionBlockedPopup
                title={t("Access cannot be removed")}
                show={showAccessDeletionBlockedPopup}
                handleClose={handleCloseAccessDeletionBlockedPopup}
                employeeInfo={employeeInfo}
            />
            <SalaryModal
                show={showSalaryModal && salaryAccessMode !== "hidden"}
                setShowSalaryModal={setShowSalaryModal}
                employeeId={employees}
                refetch={employeesRefetch}
                t={t}
                toggleShowToast={toggleShowToast}
                accessMode={salaryAccessMode}
            />
            <BookingSettingsModal
                show={showBookingSettingsModal && !!selectedEmployee && bookingAccessMode !== "hidden"}
                toggleModal={handleToggleBookingSettingsModal}
                selectedEmployee={selectedEmployee}
                refetch={employeesRefetch}
                toggleShowToast={toggleShowToast}
                accessMode={bookingAccessMode}
            />
            <DeleteEmployeeModal
                show={deleteModalShow && !!selectedEmployee && canDismissEmployee}
                onHide={() => setDeleteModalShow(false)}
                selectedEmployee={selectedEmployee}
                refetch={employeesRefetch}
            />
            {showToast && <ToastComponent show={showToast} setShow={setShowToast} text={t("Saved")} />}
            {isErrorModalOpen && (
                <ErrorModalComponent
                    i18n={i18next}
                    onClose={() => {
                        setIsErrorModalOpen(null);
                    }}
                    isOpen={!!isErrorModalOpen}
                    currentError={isErrorModalOpen}
                />
            )}
        </>
    );
};

export default EditingEmployee;
